import React from 'react';
import { styled } from '@mui/material/styles';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import List from '@mui/material/List';
import Link from 'next/link';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import Typography from '@mui/material/Typography';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { useSelector } from 'react-redux';
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
}));

const CategorySubCat = ({ check, son, index, handleCheck }) => {
    const { pageSpinner } = useSelector((state) => state.globalReducer);
    const { categoryLoaders } = useSelector((state) => state.categoryReducer);

    return (
        <Link shallow={true} scroll={false} key={son.name} className="pb-0 pt-0" href={`/${son.slug}`} style={{ textDecoration: 'none' }} onClick={(e) => handleCheck(e, index, son.slug)}>
            <AccordionDetails className="p-0">
                <List className="pb-0 pt-0">
                    <ListItem disabled={pageSpinner || categoryLoaders.fetchingCategory} className='p-0'>
                        <ListItemButton
                            className='d-flex pl-2 p-0 m-0 text-vertical'
                            sx={{
                                color: check == index ? 'white.main' : '#596164',
                                backgroundColor: check == index ? 'primary.main' : '#fff',
                                border: 'none',
                                ":hover": {
                                    backgroundColor: check == index ? 'primary.main' : '#F5F5F5',
                                    color: check == index ? 'primary.contrastText' : 'primary.main',
                                },
                                transition: 'color 0.2s ease-in-out',
                                '&:hover .MuiIconButton-root, &:hover .MuiTypography-root': {
                                    // color: 'primary.main',
                                },
                            }}
                        >

                            <ArrowRightIcon fontSize="medium" />
                            <Typography className='ml-1 pl-2 pb-1 pt-1' sx={{ fontSize: '14px' }}>{son?.name}</Typography>
                        </ListItemButton>
                    </ListItem>
                </List>
            </AccordionDetails>
        </Link>
    );
};

export default CategorySubCat;